import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../ai-answer-dialog/types';

export const onAgentKnowledgeCardCarouselItemClick = (
	props: commonAttributesType & { agentId: string; position: number },
): AnalyticsEventPayload => {
	const { source, agentId, position } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAgentKnowledgeCardCarousel',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			agentId,
			position,
		},
	};
};
